module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-96x96-02e84b39f7df9f2e4e0e3668cd8b690c.png";